import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface Country {
  _id: string;
  name: string;
  iso2: string;
}

interface State {
  _id: string;
  name: string;
}

export const getCountries = async () => {
  const response = await baseAPI.get<Array<Country>>('/studios/countries/all');
  return response.data;
};

export const getStatesByCountry = async (countryId: string) => {
  const response = await baseAPI.get<Array<State>>(
    `/studios/states/all/${countryId}`,
  );
  return response.data;
};

export const useGetCountriesQuery = () => {
  return useQuery({
    queryKey: [KEYS.COUNTRIES_ALL],
    queryFn: getCountries,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};

export const useGetStatesByCountryQuery = (country: string) => {
  return useQuery({
    queryKey: ['states', country],
    queryFn: () => getStatesByCountry(country),
    enabled: !!country, // Only run the query if country is provided
  });
};
